import {
  API_EMPLOYEE_BULK_REVIEW_TEMPLATE,
  API_EMPLOYEE_REVIEW_MY_CONSOLIDATE,
  API_EMPLOYEE_REVIEW_QUESTIONNAIRE,
  API_EMPLOYEE_REVIEW_REVIEWEE_ASSIGNMENT,
  API_EMPLOYEE_REVIEW_SUMMARY,
  API_POST_EMPLOYEE_BULK_REVIEW_UPLOAD,
  API_EMPLOYEE_REVIEW_REVIEWER_ASSIGNMENT,
  API_POST_EMPLOYEE_REVIEW_SYNC_REVIEWEE,
  API_POST_EMPLOYEE_REVIEW_SYNC_REVIEWER,
} from '../../const/Api';
import {RestApiMethod} from '../../const/dataEnum';
import {callAPI} from './callApi';

const getQuestionnareByReviewIdAndDepartmentId = async (reviewId, departmentId) => {
  try {
    const response = await callAPI({
      method: RestApiMethod.GET,
      url: API_EMPLOYEE_REVIEW_QUESTIONNAIRE.replace('{REVIEW_ID}', reviewId).replace('{DEPARTMENT_ID}', departmentId),
    });
    return response.data.data;
  } catch (error) {
    console.error('getQuestionnareByReviewIdAndDepartmentId Error:', error.message);
    return null;
  }
};

const getMyConsolidatedReview = async () => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_EMPLOYEE_REVIEW_MY_CONSOLIDATE,
    });
    return res.data;
  } catch (error) {
    console.error('employeeReviewApi getMyConsolidatedReview Error:', error.message);
    return null;
  }
};

const getRevieweeAssigment = async ({
  periodId,
  employee,
  practiceId,
  projectId,
  departmentId,
  sortBy = 'fullName',
  sortType = 'asc',
  pageNo = 1,
  pageSize = 10,
  cancelToken,
}) => {
  try {
    const params = {
      employee,
      practiceId,
      projectId,
      departmentId,
      sortBy,
      sortType,
      pageNo,
      pageSize,
    };

    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_EMPLOYEE_REVIEW_REVIEWEE_ASSIGNMENT.replace('{PERIOD_ID}', periodId),
      params,
      cancelToken,
    });

    return res.data;
  } catch (error) {
    console.error('getRevieweeAssigment error:', error.message);
    return null;
  }
};

const getEmployeeReviewSummary = async (periodId, params) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.GET,
      url: `${API_EMPLOYEE_REVIEW_SUMMARY}/${periodId}`,
      params,
    });
    return res.data;
  } catch (error) {
    console.error('getEmployeeReviewSummary error:', error.message);
    return null;
  }
};

const getBulkReviewTemplate = async (employeeIds = []) => {
  try {
    return await callAPI({
      method: RestApiMethod.GET,
      url: API_EMPLOYEE_BULK_REVIEW_TEMPLATE,
      params: {
        employeeIds: employeeIds.join(),
      },
      responseType: 'arraybuffer',
    });
  } catch (error) {
    console.error('getBulkReviewTemplate error:', error.message);
    return null;
  }
};

const uploadBulkReview = async (formData) => {
  try {
    const response = await callAPI({
      method: RestApiMethod.POST,
      url: API_POST_EMPLOYEE_BULK_REVIEW_UPLOAD,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

const getReviewerAssignment = async ({
  periodId,
  employee,
  practiceId,
  projectId,
  departmentId,
  sortBy = 'fullName',
  sortType = 'asc',
  pageNo = 1,
  pageSize = 10,
}) => {
  try {
    const params = {
      employee,
      practiceId,
      projectId,
      departmentId,
      sortBy,
      sortType,
      pageNo,
      pageSize,
    };

    const res = await callAPI({
      method: RestApiMethod.GET,
      url: API_EMPLOYEE_REVIEW_REVIEWER_ASSIGNMENT.replace('{PERIOD_ID}', periodId),
      params,
    });

    return res.data;
  } catch (error) {
    console.error('getReviewerAssignment error:', error.message);
    return null;
  }
};

const syncReviewer = async (data, params) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_POST_EMPLOYEE_REVIEW_SYNC_REVIEWER,
      data,
      params,
    });
    return res.data;
  } catch (error) {
    console.error('sync reviewer error:', error.message);
    return null;
  }
};

const syncReviewee = async (data, params) => {
  try {
    const res = await callAPI({
      method: RestApiMethod.POST,
      url: API_POST_EMPLOYEE_REVIEW_SYNC_REVIEWEE,
      data,
      params,
    });
    return res.data;
  } catch (error) {
    console.error('sync reviewee error:', error.message);
    return null;
  }
};

const employeeReviewApi = {
  getQuestionnareByReviewIdAndDepartmentId,
  getMyConsolidatedReview,
  getRevieweeAssigment,
  getEmployeeReviewSummary,
  getBulkReviewTemplate,
  uploadBulkReview,
  getReviewerAssignment,
  syncReviewer,
  syncReviewee,
};

export default employeeReviewApi;
